//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};
window.Popper = require('@popperjs/core');

//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// Or import only needed plugins
import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
require('bootstrap');

//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { Draggable } from "gsap/dist/Draggable"; // Draggableを追加
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

//=====================================
//SplitType
//=====================================
const SplitType = require('split-type').default;
window.SplitType = SplitType;

//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

//=====================================
// SweetAlert2
//=====================================
import Swal from 'sweetalert2';
window.Swal = Swal;
// Example usage of SweetAlert2
// document.addEventListener('DOMContentLoaded', () => {
//     const modalBtn = document.getElementById('modalBtn');
//     if (modalBtn) {
//         modalBtn.addEventListener('click', () => {
//             Swal.fire({
//                 title: 'モーダルタイトル',
//                 text: 'これは説明文です。',
//                 icon: 'info',
//                 confirmButtonText: '閉じる'
//             });
//         });
//     }
// });

//=====================================
//FANCY BOX
//=====================================
// import {Fancybox } from "@fancyapps/ui";
// window.Fancybox = Fancybox;

//=====================================
//Muuri
//=====================================
const Muuri = require('muuri').default;
window.Muuri = Muuri;
$(function(){
/////////////////////////////////////////////
//TOOLTIP
/////////////////////////////////////////////
  $('[data-toggle="tooltip"]').tooltip()
/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
window.App.loadSection = function(url, modalId,modalTitle) {
  $.ajax({
    type: 'GET',
    url: url,
    success: function(data) {
      $(modalId).find(".ajx_content_output").html(data);
      $(modalId).find('.modal-title').html(modalTitle);
      $(modalId).modal('show');
    }
  });
};
/////////////////////////////////////////////
//SP BUGER MENU
/////////////////////////////////////////////
$('#global_burgermenu > button').on('click', function() {
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
      $('body').addClass('is-sp-menu');
      $('body').removeClass('rm-sp-menu');
  }else{
      $('body').removeClass('is-sp-menu');
      $('body').addClass('rm-sp-menu');
  }
  return false;
});

$("#global-sp-menu").on("click",function(){
  $('#global_burgermenu > button').trigger('click');
})

$(document).on('click', function(event) {
  if ($('body').hasClass('is-sp-menu') && !$(event.target).closest("#global-sp-menu").length) {
    $('#global_burgermenu > button').trigger('click');
  }
});

//////////////////////
//SCROLL ANIMTAION
//////////////////////
// URLのハッシュが存在するかチェック
 if (window.location.hash) {
  var targetId = window.location.hash.substring(1);
  var targetElement = $('#' + targetId);
  if (targetElement.length > 0) {
    targetElement.click();
    setTimeout(function() {
      var targetOffset = targetElement.offset().top;
      var bodyOffset = $('body').scrollTop();
      var scrollTo = targetOffset - bodyOffset;
      $('html, body').animate({
        scrollTop: scrollTo
      }, 800);  // スクロール時間（ミリ秒）
    }, 10);  // 適宜調整した遅延時間
  }
}

 // URLのハッシュを削除
$(window).on('scroll', function() {
  clearTimeout(window.scrollTimeout);
  window.scrollTimeout = setTimeout(function() {
    if (window.location.hash !== '') {
      history.replaceState(null, null, ' '); // ハッシュを削除
    }
  }, 150);  // スクロール停止後150ミリ秒後に実行
});


var headerH = $("#header").outerHeight(true);//headerの高さを取得    
function FixedAnime() {
  var scroll = $(window).scrollTop();
  if (scroll >= headerH){//headerの高さを超えたら
        $('body').addClass('is_scroll');
  }else{
        $('body').removeClass('is_scroll');
  }    
}
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
});

//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }

  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    spaceBetween: 10,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}

///////////////////////////////////////////////////////////
//FAQ ETC
//////////////////////////////////////////////////////////////
$(".lst-slidedown").find("li").on("click", function(){
  if ($(this).hasClass("shown")) {
    $(this).removeClass("shown");
  } else {
    $(this).addClass("shown");
  }
});
///////////////////////////////////////////////////////////
///MURRI
//////////////////////////////////////////////////////////////
window.App .initializeMuuri = function(muriId) {
  var gridOptions = {
  items: '*',
  showDuration: 300,
  showEasing: 'ease',
  hideDuration: 300,
  hideEasing: 'ease',
  layoutOnResize: 150,
  layoutOnInit: true,
  layoutDuration: 300,
  layoutEasing: 'ease',
  sortData: null,
  layout: {
      fillGaps: true,
      horizontal: false,
      alignRight: false,
      alignBottom: false,
      rounding: 'ceil' // 並べ方のオプションを設定[]
      // rounding:'true'
  },
  // visibleStyles: {
  // opacity: '1',
  // transform: 'scale(1)'
  // },
  // hiddenStyles: {
  // opacity: '0',
  // transform: 'scale(0.5)'
  // },
  // Drag & Drop
  // dragEnabled: true,
  // dragContainer: null,
  // dragHandle: null,
  // dragStartPredicate: {
  //   distance: 0,
  //   delay: 0
  // },
};
var gridALL = new Muuri(muriId, gridOptions);
//Random
// function randomizeOrder(items) {
//   var shuffled = items.slice(0);
//   for (var i = shuffled.length - 1; i > 0; i--) {
//     var rand = Math.floor(Math.random() * (i + 1));
//     var temp = shuffled[i];
//     shuffled[i] = shuffled[rand];
//     shuffled[rand] = temp;
//   }
//   return shuffled;
// }
function filterDo() {
var selectElms = $(".js-sort-btn .active");
var selectElemAry = [];
$.each(selectElms, function(index, selectElm) {
 var className = $(this).attr("class");
 className = className.split(' ');
 selectElemAry.push("." + className[0]);
});
var str = selectElemAry.join(',');
gridALL.filter(str);
}
// Event Function
  $('.js-sort-btn li').on('click', function() {
  $(".js-sort-btn li").removeClass("active");
  $(".cat_all").addClass("active");
  $(this).addClass("active");
  var className = $(this).attr("class");
  className = className.split(' ');
  console.log(className);
  filterDo();
});
// $('.cat_all').on('click', function() {
//   $(".js-sort-btn li").addClass("active");
//   $(".cat_all").removeClass("active");
//   filterDo();
// });
//Page loaded
// filterDo();
}


////////////////////////////////////
/// DEV
////////////////////////////////////
$(".dev-bg i").on("click", function(e) {
e.preventDefault();
var classNum = $(this).data("bg");
if(classNum === "none"){
    $(this).parent(".dev-bg").remove();
}
$(this).closest("SECTION, .swiper-slide").removeClass(function(index, className) {
    return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
}).addClass("mv-" + classNum);
});
$('[data-js="add_hover"]').hover(function() {
$(this).closest('SECTION').addClass('is_hover');
}, function() {
$(this).closest('SECTION').removeClass('is_hover');
});


//////////////////////////////
//カウントアップ
//////////////////////////////
$(".txt-num > i").each(function(index, element) {
  var $target = $(element);
  var targetText = $target.text();
  var targetNumber = parseInt(targetText, 10);
  var paddingLength = targetText.length; // 元の文字列の桁数を保持

  var duration = 500; // アニメーションの継続時間（ミリ秒）
  var currentNumber = 0; // 現在の数字

  function animateNumber() {
    $({ countNum: currentNumber }).animate({ countNum: targetNumber }, {
      duration: duration,
      easing: 'linear',
      step: function() {
        var value = Math.floor(this.countNum).toString().padStart(paddingLength, '0');
        $target.text(value);
        $target.addClass('animating').removeClass("animating_done"); 
      },
      complete: function() {
        var finalValue = targetNumber.toString().padStart(paddingLength, '0');
        $target.text(finalValue);
        $target.removeClass('animating').addClass("animating_done");
      }
    });
  }

  // カウントアップのアニメーションをスクロールトリガーとして設定
  gsap.to({}, {
    duration: 0.01,
    scrollTrigger: {
      trigger: $target.parent(), // 親要素をトリガーにする
      start: "top 80%", // スクロール位置でトリガー
      onEnter: animateNumber, // 要素がビューポートに入ったときにアニメーションを開始
      // markers: true // マーカーを表示（デバッグ用）
    }
  });
});

});



////////////////////////////////
// const mvImgElements = $('.mvimg').not("#section-recruit");
// mvImgElements.each(function(index, mvImgElement) {
//   const boxElement = $(mvImgElement).find('.box');
//   gsap.set(boxElement, { filter: 'blur(0px)' });
//   gsap.to(boxElement, {
//     filter: 'blur(10px)', // ぼかしをかける
//     ease: 'power1.inOut', // イージングを設定
//     scrollTrigger: {
//       trigger: mvImgElement,
//       start: 'top top',// トリガー要素の上端がビューポートの下端に達したらアニメーション開始
//       end: 'top+=1% top',     
//       scrub: 1,
//     }
//   });

// });



// const mvImgElements2 = $('.mvimg');
// mvImgElements2.each(function(index, mvImgElement) {
//   const boxElement2 = $(mvImgElement).find('article');
//   const accEnBeforeElement = $(mvImgElement).find('.acc_arc');

//   gsap.set(boxElement2, { 
//     filter: 'blur(10px)',
//     x:20,
//     // opacity:0,
//     }
//     );
//     gsap.to(boxElement2, {
//       x: 0,
//       opacity:1,
//       filter: 'blur(0px)', // ぼかしをかける
//       ease: 'power1.inOut', // イージングを設定
//       scrollTrigger: {
//         trigger: mvImgElement,
//         start: 'top-=30% top',// トリガー要素の上端がビューポートの下端に達したらアニメーション開始
//         end: 'top-=30% top',     
//         scrub: 2,
//       }
//     });

//   gsap.fromTo(accEnBeforeElement, {
//     opacity:0,
//     x: 120, 
//   }, {
//     opacity:.5,
//     x: 0, 
//     ease: 'none', // イージングを設定
//     scrollTrigger: {
//       trigger: mvImgElement,
//       start: 'top-=30% top',// トリガー要素の上端がビューポートの下端に達したらアニメーション開始
//       end: 'top-=30% top',    
//       scrub: 1, // スクロール時にアニメーションを進める割合
//     }
//   });
// });

//.acc-en-before の要素も開始から終了までrotateで３週回したい。
/////////////////////////////////////

//////////////////////////////////
/*右から移動*/
// $('.am-x-r').each(function(index, elm) {
//   gsap.from(elm, {
//     x: 300,
//     autoAlpha: 0,
//     opacity: 0,
//     duration: 0.5, 
//     ease: "power2.out",
//     scrollTrigger: {
//       trigger: elm,
//       start: 'top-=100px bottom', // 開始位置を早めに
//       end: 'bottom-=800px top',   // 最終位置を早めに停止
//       scrub: 1
//     }
//   });
// });
// // 左から移動
// $('.am-x-l').each(function(index, elm) {
//     gsap.from(elm, {
//     x: -300,
//     autoAlpha: 0,
//     opacity: 0,
//     duration: 0.1, 
//     ease: "power2.out",
//     stagger: 1.02,
//     scrollTrigger: {
//     trigger: elm,
//     start: 'top-=200px bottom', // 開始位置を早めに
//     end: 'bottom-=800px top',   // 最終位置を早めに停止
//     scrub:1
//     }
//   });
// });
// window.addEventListener('contextmenu', function (e) {
//   e.preventDefault();
// });
  // const tags = $('.icn-tags');
  // tags.each(function(index, tag) {
  //   gsap.set(tag, {transformOrigin: "50% 50%"});
  //   $(tag).mouseenter(function() {
  //     gsap.to(tag, {duration: 0.5, scale: 2, rotation: gsap.utils.random(-20, 20)});
  //   });
  //   $(tag).mouseleave(function() {
  //     gsap.to(tag, {duration: 0.5, scale: 1, rotation: 0});
  //   });
  // });
  // gsap.utils.toArray('#zzz2 .zzz').forEach( (zzz, index) => {
  //     gsap.fromTo(zzz,1,
  //       {x:-2000,
  //         rotation: 120,
  //         scale: 100,
  //         autoAlpha: 0 },
  //       {x:0,
  //         rotation: 0,
  //         scale:1,
  //         autoAlpha: 1,
  //         duration:1,
  //         scrollTrigger: {
  //         trigger: '#zzz2', //scrub: 1 // markers: true
  //         start: 'top bottom', 
  //         end: 'bottom bottom',
  //         //   scrub: 3,
  //         },
  //       }
  //     );
  // });
  // gsap.from(chars, {
  //   x: function() { return gsap.utils.random(-1500, 1500); },
  //   y: function() { return gsap.utils.random(-1500, 1500); },
  //   scale: function() { return gsap.utils.random(.1, 20); },
  //   opacity: 0,
  //   rotation: function() { return gsap.utils.random(-360, 360); },
  //   stagger: {
  //     amount: 1,
  //     from: "center"
  //   },
  //   scrollTrigger: {
  //     trigger: mvimg,
  //     start: 'top bottom',
  //     end: 'bottom bottom',
  //     toggleActions: "play none none reverse"
  //   },
  //   onComplete: function() {
  //   }
  // });



  // 画像パララックス
  // $('.am-y-plx').each(function(index, elm) {
  //   gsap.to(elm, {
  //     y: -100,
  //     ease: "none",
  //     scrollTrigger: {
  //       trigger: elm,
  //       start: 'top bottom',
  //       end: 'bottom top',
  //       scrub: 1
  //     }
  //   });
  // });

  // gsap.from("#char2 .char", {
  //   y: -500,
  //   x: -500,
  //   scale: 0,
  //   rotation: 180,
  //   stagger: .05,
  //   opacity: 0,
  //   delay: 2.2,
  //   duration: 0.6,
  //   ease: "power2.out"
  // });

  // gsap.from("#GSAP1", {
  //   x: 550,
  //   y: 300,
  //   scale: 1.8,
 
  //   scrollTrigger: {
  //     trigger:'#section-aboutus',
  //     start: 'top bottom',  // #section-aboutusの上端が画面の下端に達したら開始
  //     end: 'top-=10',     // #section-aboutusの上端から400px見えたら完了
  //     scrub: true
  //   }
  // });
  // gsap.from("#GSAP2", {
  //   x: -550,
  //   y: 300,
  //   scale: 1.8,
  //   scrollTrigger: {
  //     trigger:'#section-contact',
  //     start: 'top bottom',  // #section-aboutusの上端が画面の下端に達したら開始
  //     end: 'top-=10',     // #section-aboutusの上端から400px見えたら完了
  //     scrub: true
  //   }
  // });

  // 上から移動
  // $('.am-y-t').each(function(index, elm) {
  //   gsap.from(elm, {
  //     y: -100,
  //     autoAlpha: 0,
  //     duration: 1.5,
  //     opacity: 1,
  //     ease: "power2.out",
  //     stagger: {
  //       from: "start",
  //       amount: 0.8
  //     },
  //     scrollTrigger: {
  //       trigger: elm,
  //       start: 'top bottom',
  //       end: 'bottom top',
  //       scrub: 1
  //     }
  //   });
  // });
  // 下から移動
  // $('.am-y-b').each(function(index, elm) {
  //   gsap.from(elm, {
  //     y: 100,
  //     autoAlpha: 0,
  //     duration: 1.5,
  //     opacity: 1,
  //     ease: "power2.out",
  //     stagger: {
  //       each: 0.5,
  //       ease: "power4.out",
  //       from: "start",
  //       amount: 3.8
  //     },
  //     scrollTrigger: {
  //       trigger: elm,
  //       start: 'top bottom',
  //       end: 'bottom bottom',
  //       scrub: 1
  //     }
  //   });
  // });
  // 中央からスケール
  // $('.am-s-0').each(function(index, elm) {
  //   gsap.from(elm, {
  //     scaleX: 0.5,
  //     duration: 1.5,
  //     opacity: 0,
  //     ease: "power2.out",
  //     scrollTrigger: {
  //       trigger: elm,
  //       start: 'top bottom',
  //       end: 'bottom bottom',
  //       scrub: 1
  //     }
  //   });
  // });


/* ==================
FANCYBOX
===================== */
// Fancybox.bind('[data-fancybox]', {
//   hideScrollbar: false,
//   Toolbar: {
//     display: {
//       left: [],
//       middle: ['infobar'],
//       right: ['close'],
//     },
//   },
// });






// // .bar1要素のアニメーション
// $(".bar1").each(function(index, element) {
//   var width = $(element).width(); // バーの現在の幅を取得
//   var targetWidth = parseInt($(element).css("width")); // 目標の幅を取得
//   $(element).css("width", "0px");
//   gsap.to(element, {
//     scrollTrigger: {
//       trigger: element,
//       start: "top 80%", 
//       end: "bottom 20%",
//     },
//     width: targetWidth + "px",
//     duration: .5,
//     ease: "power2.inOut", 
//   });
// });

// $(".bar2").each(function(index, element) {
//   var height = $(element).height(); 
//   var targetHeight = parseInt($(element).css("height")); 
//   $(element).css("height", "0px");
//   gsap.to(element, {
//     scrollTrigger: {
//       trigger: element, 
//       start: "top 80%", 
//       end: "bottom 20%",
//     },
//     height: targetHeight + "px",
//     duration: .5,
//     ease: "power2.inOut", 
//   });
// });
  // gsap.from(chars, {
  //   x: function() { return gsap.utils.random(-1500, 1500); },
  //   y: function() { return gsap.utils.random(-1500, 1500); },
  //   scale: function() { return gsap.utils.random(.1, 20); },
  //   opacity: 0,
  //   rotation: function() { return gsap.utils.random(-360, 360); },
  //   stagger: {
  //     amount: 1,
  //     from: "center"
  //   },
  //   scrollTrigger: {
  //     trigger: mvimg,
  //     start: 'top bottom',
  //     end: 'bottom bottom',
  //     toggleActions: "play none none reverse"
  //   },
  //   onComplete: function() {
  //   }
  // });



  
// // オブジェクトの数
// var objectCount = 300;
// // オブジェクトの種類（四角か三角）
// var objectShapes = ['sq1','sq2','ta1','ta2'];
// // DIVの幅と高さを取得
// var boxWidth = $('#box-present').width();
// var boxHeight = $('#box-present').height();

// // オブジェクトを生成してDIVに追加
// for (var i = 0; i < objectCount; i++) {
//   var shape = objectShapes[Math.floor(Math.random() * objectShapes.length)];
//   var $object = $('<div class="object ' + shape + '"></div>');
//   $object.css({
//     top: Math.random() * boxHeight,
//     left: Math.random() * boxWidth,
//     transform: 'rotate(' + Math.random() * 360 + 'deg)'
//   });
//   $('#box-present').append($object);
// }
//     $('#box-present').on('click', function() {
//       // ウィンドウの幅と高さを取得
//       var windowWidth = $(window).width();
//       var windowHeight = $(window).height();
//       var delayTime = 500; // 0.5秒後にクラスを追加
//       $(this).addClass('a-before_start');
//       // GSAPでアニメーションを設定
//       gsap.to('.object', {
//         // duration: 1,
//         x: function() { return Math.random() * windowWidth * 2 - windowWidth; }, // x座標を画面外にランダムに設定
//         y: function() { return Math.random() * windowHeight * 2 - windowHeight; }, // y座標を画面外にランダムに設定
//         opacity:0,
//         scale:.1,
//         duration: 1.5, 
//         rotation: 360,

//        onStart: function() {
//           // アニメーションが開始した瞬間に.a-startクラスを追加
//           setTimeout(function() {
//             $('#box-present').addClass('a-start');
//           }, delayTime);

//       },

//         onComplete: function() {
//           $('#box-present').removeClass('a-start').addClass('a-end');
//           // アニメーションが完了した後に画像を表示
//           $('#box-present figure').fadeIn();
//         }
//       });
//     });
//RECRUITE LIST
// gsap.utils.toArray('#lst-top-recruit ul li').forEach((item, index) => {
//   gsap.from(item, {
//     delay: index * .6,
//     y: 50,
//     opacity: 0,
//     duration: .5,
//     ease: 'power1.inOut',
//     scrollTrigger: {
//       trigger: item, // 各li要素がトリガーになるようにする
//       start: 'top bottom',
//       end: 'bottom bottom',
//       scrub: 1,
//     },
//   });
// });
//   const mvimgs = $(".gsap-box-a");
//   mvimgs.each(function() {
//   const mvimg = $(this);
//   const chars = mvimg.find(".tit-m .char, .tit-s");
//   const titTopChars = mvimg.find(".tit-top .char");
//   gsap.from(titTopChars, {
//     x: -60,
//     // scale:112.2,
//     opacity: 0,
//     ease: "bounce.out",
//     duration: .8,
//     stagger: 0.02,
//     scrollTrigger: {
//       trigger: mvimg,
//       start: 'top bottom',
//       end: 'bottom bottom',
//     },
//     onComplete: function() {
//       gsap.to(titTopChars, {
//         x: 0,
//         // scale:1,
//         opacity: 1,
//         ease: "bounce.out",
//         duration: 1
//       });
//     }
//   });
// });


///////////////////////////////////////////////////////////////////
// ANIMATION を無効にするためにbodyにaniamtion-activeについたばあいのみ実行させる
///////////////////////////////////////////////////////////////////
// function getParameterByName(name, url) {
//   if (!url) url = window.location.href;
//   name = name.replace(/[\[\]]/g, "\\$&");
//   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
//       results = regex.exec(url);
//   if (!results) return null;
//   if (!results[2]) return '';
//   return decodeURIComponent(results[2].replace(/\+/g, " "));
// }
// var disableAnimationParam = getParameterByName('noanime');// URLパラメーター"anime"の値を取得
// if (!disableAnimationParam) {// body要素にクラスを追加
//   $('body').addClass('animation-active');
// }
// if ($('body').hasClass('animation-active')) {
// TOP PAGE MV
//   gsap.from("#section-00 .v-txt01", {
//     x:-20,
//     delay: .2,
//     opacity: 0,
//     duration: .8,
//     ease: "power2.out"
//   });
//   const flexcol2 = $(".flex-col2");
//   flexcol2.each(function() {
//   const flexcol2 = $(this);
//   const div1 = flexcol2.find(".order-md-1");
//   const div2 = flexcol2.find(".order-md-2");
//   const div3 = flexcol2.find(".order-md-3");
//   gsap.from(div1, {
//     x: -20,
//     opacity: 0,
//     ease: 'power1.inOut',
//     duration: .6,
//     scrollTrigger: {
//       trigger: div1,
//       start: 'top bottom',
//       end: 'bottom bottom',
//       scrub: 1,
//     },
//   });

//   gsap.from(div2, {
//     x:300,
//     opacity: 0,
//     ease: 'power1.inOut',
//     duration: 1,
//     scrollTrigger: {
//       trigger: div1,
//       start: 'top bottom',
//       end: 'bottom bottom',
//       scrub: 1,
//     },
//   });
// });